import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTableGame = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.544 9.832a1.75 1.75 0 0 1 2.912 0l.798 1.197a1.75 1.75 0 0 1 0 1.942l-.798 1.197a1.75 1.75 0 0 1-2.912 0l-.798-1.197a1.75 1.75 0 0 1 0-1.942zm1.664.832a.25.25 0 0 0-.416 0l-.798 1.197a.25.25 0 0 0 0 .278l.798 1.197a.25.25 0 0 0 .416 0l.798-1.197a.25.25 0 0 0 0-.278z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 5.85a6.15 6.15 0 1 0 0 12.3 6.15 6.15 0 0 0 0-12.3M7.35 12a4.65 4.65 0 1 1 9.3 0 4.65 4.65 0 0 1-9.3 0"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M18.6 16.2a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0M18 8.4a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2M6.6 7.8a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0M12.52 4.404a.6.6 0 1 0-1.04.6.6.6 0 0 0 1.04-.6M11.7 18.777a.6.6 0 1 1 .6 1.039.6.6 0 0 1-.6-1.04M6 16.8a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-1.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgTableGame;
